export default __webpack_public_path__ + "static/media/flowls_white_mini_text.1b7b4c14.png";